export enum CommunicationPlatform {
    Kandy = 'kandy',
    Skype = 'skype',
    SkypeDomain = 'skypedomain',
    SkypeIWA = 'skypeiwa',
    SkypeOnline = 'skypeonline',
    Teams = 'teams',
    Test = 'test',
    Unknown = 'unknown'
}
